import { onReadyWidgetOfType } from "../utils/helper"

onReadyWidgetOfType("AccordionWithImage", (widget, data) => {
  // console.log("AccordionWithImage", { widget })
  const accordion = widget.querySelector(".accordion")
  /** @type {HTMLImageElement} */
  const imageTarget = widget?.querySelector(".accordion-image")
  accordion?.addEventListener("show.bs.collapse", (e) => {
    // console.log("accordion event", imageSource, e)
    const imageSource = e.target.getAttribute("data-event-image")
    if (imageTarget && imageSource) {
      imageTarget.src = imageSource
    }
  })
})